const KEY = 'holidayBadgingData';

type StoredValue = {
  value: EventBadgingValue;
  expiry: number;
};

type EventBadgingValue = string | Record<string, unknown>;

export function getEventData() {
  const data = localStorage.getItem(KEY);
  if (!data) {
    return null;
  }
  const eventData = JSON.parse(data) as StoredValue;
  const now = new Date();
  if (now.getTime() > eventData.expiry) {
    localStorage.removeItem(KEY);
    return null;
  }
  return eventData.value;
}

export function setEventData(value: EventBadgingValue) {
  const now = new Date();

  const item: StoredValue = {
    value,
    expiry: now.getTime() + 14400000,
  };
  localStorage.setItem(KEY, JSON.stringify(item));
}
